import makeSlug from "@/utils/makeSlug";
import { useMarket } from "@features/market/useMarket";
import { clearGuestWishlistMergeState } from "@features/account/utils/mergeGuestWishlist";
import { useRouter } from "next/navigation";
import clearAuthCookie from "../services/clearAuthCookie";
import { clearSessionEstablishment } from "../services/establishSession";
import useAuth from "./useAuth";

type SignOutOptions = {
  /** Defaults to market home. Pass false to stay on the current page. */
  redirectTo?: string | false;
};

export default function useSignOut() {
  const { auth } = useAuth();
  const router = useRouter();
  const market = useMarket();

  return async (options?: SignOutOptions) => {
    try {
      if (auth?.currentUser) {
        const { signOut } = await import("firebase/auth");
        await signOut(auth);
      }
    } catch (error: unknown) {
      console.error(error);
    } finally {
      clearSessionEstablishment();
      clearGuestWishlistMergeState();
      await clearAuthCookie();

      if (options?.redirectTo !== false) {
        router.push(options?.redirectTo ?? makeSlug(market.siteLocale));
      }
    }
  };
}
